/* istanbul ignore file */
// There is very little benefit in testing this wrapper so we are happy to exclude it from coverage
// Uses dnd kit - Reference: https://docs.dndkit.com/
import {
  useSensors,
  useSensor,
  PointerSensor,
  KeyboardSensor,
  DragEndEvent,
  DndContext,
  closestCenter,
} from '@dnd-kit/core';
import {
  sortableKeyboardCoordinates,
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { SetStateAction } from 'react';

export const SortableListProvider = ({
  children,
  values,
  setValues,
}: {
  children: React.ReactNode;
  values: string[];
  setValues: (value: SetStateAction<string[]>) => void;
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
      keyboardCodes: {
        start: ['Space'],
        cancel: ['Escape'],
        end: ['Space'],
      },
    }),
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (over?.id && active.id !== over.id) {
      setValues(value => {
        const oldIndex = value.indexOf(active.id as string);
        const newIndex = value.indexOf(over.id as string);
        const newOrder = arrayMove(value, oldIndex, newIndex);

        return newOrder;
      });
    }
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={values} strategy={verticalListSortingStrategy}>
        {children}
      </SortableContext>
    </DndContext>
  );
};
